import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import cn from "classnames";
import styles from "./NameAndDescription.module.sass";
import { Link } from "react-router-dom";
import Icon from "../../../components/Icon";

// Screens
import StudentInformations from "./StudentInformations";
import AddressInformations from "./AddressInformations";
import StudyInformations from "./StudyInformations";
import OtherInformations from "./OtherInformations";
import LegalGuardianInformations from "./LegalGuardianInformations";
import AddressLegalGuardianInformations from "./AddressLegalGuardianInformations";

// Services
import { updateStudent, getStudentById } from "../../../services/student.service";
import { showSuccess, showError } from "../../../services/toast.service";

const NameAndDescription = ({ student: initialStudent }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [studentData, setStudentData] = useState({});
  const [isMinor, setIsMinor] = useState(false);

  // Récupérer les données complètes de l'étudiant à partir de son ID
  useEffect(() => {
    const fetchCompleteStudentData = async () => {
      if (initialStudent && initialStudent.id) {
        try {
          setLoading(true);
          // Récupérer les données complètes de l'étudiant via le service
          const completeStudentData = await getStudentById(initialStudent.id);
          setStudentData(completeStudentData);
          
          // Vérifier si l'étudiant est mineur
          if (completeStudentData.birth_date) {
            const birthDate = new Date(completeStudentData.birth_date);
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
              age--;
            }
            setIsMinor(age < 18);
          }
        } catch (err) {
          console.error("Erreur lors de la récupération des données complètes de l'étudiant:", err);
          setError("Impossible de récupérer les données complètes de l'étudiant.");
          // Utiliser les données initiales si la récupération échoue
          setStudentData(initialStudent);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchCompleteStudentData();
  }, [initialStudent]);

  const handleStudentChange = (e) => {
    const { name, value } = e.target;
    setStudentData((prev) => ({ ...prev, [name]: value }));

    if (name === "birth_date") {
      if (value) {
        const birthDate = new Date(value);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        setIsMinor(age < 18);
      } else {
        setIsMinor(false);
      }
    }
  };

  const handleSwitchChange = (name, value) => {
    setStudentData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDropdownChange = (name, value) => {
    setStudentData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      // Utiliser updateStudent au lieu de createStudent
      await updateStudent(studentData.id, studentData);
      showSuccess("Élève mis à jour avec succès!");
    } catch (err) {
      const errorMessage =
        "Impossible de mettre à jour l'élève: " +
  
  
      showError(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.formContainer}>
          {loading ? (
            <div className={styles.loading}>
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Chargement...</span>
              </div>
              <p>Chargement des données complètes de l'étudiant...</p>
            </div>
          ) : (
          <form onSubmit={handleSubmit}>
            <StudentInformations
              student={studentData}
              onStudentChange={handleStudentChange}
              onDropdownChange={handleDropdownChange}
            />
            <AddressInformations
              student={studentData}
              onStudentChange={handleStudentChange}
            />
            {isMinor && (
              <>
                <LegalGuardianInformations
                  student={studentData}
                  onStudentChange={handleStudentChange}
                  onDropdownChange={handleDropdownChange}
                />
                <AddressLegalGuardianInformations
                  student={studentData}
                  onStudentChange={handleStudentChange}
                />
              </>
            )}
            <OtherInformations
              student={studentData}
              onStudentChange={handleStudentChange}
              onSwitchChange={handleSwitchChange}
              onDropdownChange={handleDropdownChange}
            />
            <StudyInformations
              student={studentData}
              onStudentChange={handleStudentChange}
              onDropdownChange={handleDropdownChange}
              onSwitchChange={handleSwitchChange}
              loading={loading}
            />
            
  </form>
          )}
        </div>
      </div>
    </>
  );
};

export default NameAndDescription;
